import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import './styles.css';
import { MenuItem } from '@material-ui/core';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     width: '100%',
    //     backgroundColor: theme.palette.background.paper,
    // },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    adornedEnd: {
        width: '20px',
        marginLeft: '300px',
        fontSize: '8px',
        height: '17px',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    mt15: {
        marginTop: '15px !important',
    },
    selectView: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '14px',
        paddingTop: '15px',
        '& .MuiSelect-icon': {
            // display: 'none',
            // right: '50%',
        },
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    btnGrey: {
        color: '#ccc !important',
        border: '1px solid #ccc !important',
        cursor: 'default',
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function DifferentSource() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [records, setrecordsType] = useState('none');
    const [expenditure, setExpenditure] = useState('Expediture');
    const [booksAcc, setbooksAcc] = useState('none');
    const [tally, setTally] = useState('Tally');
    const [zoho, setZoho] = useState('none');
    const [others, setOthers] = useState('none');

    const [formValues, setformValues] = React.useState({
        nameEmployer: 'Enter Employer',
        investment: 'Enter Investments',
        investmentAmt: 'Enter Amount',
        donationDetails: 'Enter Donation details',
        donationAmt: 'Enter Amount',
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // if (expenditure === 'expenditure') {
    //     setExpenditure('block');
    // }
    const handleRoleChange = (event) => {
        setExpenditure(event.target.value);

        switch (event.target.value) {
            case 'expenditure':
                setExpenditure('block');
                setrecordsType('none');
                setbooksAcc('none');
                //console.log('expenditure');

                return true;
            case 'records':
                setrecordsType('block');
                setExpenditure('none');
                setbooksAcc('none');
                //console.log('records');
                return true;
            case 'booksAcc':
                setbooksAcc('block');
                setExpenditure('none');
                setrecordsType('none');
                //console.log('banksAcc');
                return true;
            case 'tally':
                setTally('block');
                setZoho('none');
                setOthers('none');
                //console.log('banksAcc');
                return true;
            case 'zoho':
                setTally('none');
                setZoho('block');
                setOthers('none');
                //console.log('banksAcc');
                return true;
            case 'others':
                setTally('none');
                setZoho('none');
                setOthers('block');
                //console.log('banksAcc');
                return true;

            default:
                return true;
        }
    };
    const [state, setState] = React.useState({
        tally: '',
        zoho: '',
        others: '',
    });

    return (
        <div className="main-container w100">
            <AppBar position="static" color="default" className="custom-tab">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    <Tab label="Salary" {...a11yProps(0)} />
                    <Tab label="House Property" {...a11yProps(1)} />
                    <Tab label="Business or Profession" {...a11yProps(2)} />
                    <Tab label="Capital Gain" {...a11yProps(3)} />
                    <Tab label="Other Sources" {...a11yProps(4)} />
                    <Tab label="Agricultural Income" {...a11yProps(5)} />
                    {/* <Tab label="Deductions" {...a11yProps(6)} /> */}
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you have income from salary/pension?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option mb15"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                                <FormControl fullWidth className="mt15">
                                    <InputLabel htmlFor="name-of-the-employer">Name of the Employer</InputLabel>
                                    <Input
                                        disabled
                                        className={classes.bottomLine}
                                        id="name-of-the-employer"
                                        value={formValues.nameEmployer}
                                        // onChange={handleChange('amount')}
                                    />
                                    <Typography variant="caption" gutterBottom>
                                        (Ensure you have uploaded Part A and Part B of Form 16)
                                        <br />
                                        (If you have more than 1 employer, ensure you have attached all the Form 16s)
                                    </Typography>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Details of investments/savings like LIC premium, Mediclaim, PPF, NSC, Children school fees etc..
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="investments">Particulars</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="investments"
                                value={formValues.investment}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="amount-investment">Amount</InputLabel>
                            <Input disabled className={classes.bottomLine} id="amount-investment" value={formValues.investmentAmt} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Donation details
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="donation-details">Particulars</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="donation-details"
                                value={formValues.donationDetails}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="donation-amount">Amount</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="donation-amount"
                                value={formValues.donationAmt}

                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you have income from house property?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">House Address</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.houseAddress}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                House Status
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="letout"
                                        aria-label="aadhar"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="letout" control={<StyledRadio />} label="Letout" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="selfOccupied"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="Self Occupied"
                                                    className="cursor-default"
                                                />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="vacant"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="Vacant"
                                                    className="cursor-default"
                                                />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="deemedLetout"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="Deemed Letout"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">Rent received(in Rs.)</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.rent}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">Property tax paid(in Rs.)</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.propTax}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">Name of the tenant</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.tenantName}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">PAN or Aadhar</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.pan}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                House purpose
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="commercial"
                                        aria-label="aadhar"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="commercial" control={<StyledRadio />} label="Commercial" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="residential"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="Residential"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Property Co-Owned
                            </Typography>
                        </FormControl>

                        <div>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel
                                                value="no"
                                                control={<StyledRadio />}
                                                disabled
                                                label="No"
                                                className="cursor-default"
                                            />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">Co-Owner name</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.coownerName}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">Co-Owner PAN</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.coownerPan}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">% of Share</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={formValues.share}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                        <div>
                            {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                className={clsx(classes.button, classes.mt15, classes.btnGrey)}
                            >
                                Add More
                            </Button>
                        </div>
                    </Grid>
                    {/*      */}

                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Have you taken any housing loan?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="no"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Upload Housing Loan Statement
                                        </Button>
                                    </div>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                TDS deducted in rent?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="no"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Upload TDS Certificate
                                        </Button>
                                    </div>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you have income from Business/Profession?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                What is the nature of your business / profession?
                            </Typography>
                            <div>
                                <FormControl fullWidth className={classes.margin}>
                                    <InputLabel htmlFor="enter-the-nature">Enter the nature</InputLabel>
                                    <Input
                                        disabled
                                        className={classes.bottomLine}
                                        id="enter-the-nature"
                                        value={formValues.natureBusiness}
                                        // onChange={handleChange('amount')}
                                    />
                                </FormControl>
                            </div>
                        </FormControl>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom className="mt15">
                                How do you wish to provide the details of your business/professional income?
                            </Typography>
                        </FormControl>
                        <FormControl component="fieldset">
                            <RadioGroup
                                disabled
                                defaultValue="expenditure"
                                aria-label="business"
                                name="customized-radios"
                                onChange={handleRoleChange}
                                className="radio-option"
                            >
                                <ul className={classes.expenditure}>
                                    <li>
                                        <FormControlLabel
                                            value="expenditure"
                                            control={<StyledRadio />}
                                            label="I will give you details of income and expenditure"
                                        />
                                    </li>
                                    <li>
                                        <FormControlLabel
                                            value="records"
                                            control={<StyledRadio />}
                                            disabled
                                            label="I will give you all my records you compute income and expenditure"
                                            className="cursor-default"
                                        />
                                    </li>
                                    <li>
                                        <FormControlLabel
                                            value="booksAcc"
                                            control={<StyledRadio />}
                                            disabled
                                            label="I will share the books of accounts "
                                            className="cursor-default"
                                        />
                                    </li>
                                </ul>
                            </RadioGroup>
                        </FormControl>
                        <div style={{ display: expenditure }}>
                            <Grid container spacing={4}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className={classes.margin}>
                                        <InputLabel htmlFor="total-receipts">Total Receipts</InputLabel>
                                        <Input
                                            disabled
                                            className={classes.bottomLine}
                                            id="total-receipts"
                                            value={formValues.totalReceipts}
                                            // onChange={handleChange('amount')}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className={classes.margin}>
                                        <InputLabel htmlFor="total-expenses">Total Expenses</InputLabel>
                                        <Input
                                            disabled
                                            className={classes.bottomLine}
                                            id="total-expenses"
                                            value={formValues.totalExpenses}
                                            // onChange={handleChange('amount')}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div>
                        <div style={{ display: records }}>
                            <Grid container spacing={4}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className={classes.margin}>
                                        <InputLabel htmlFor="GST-return-document">Upload GST returns document</InputLabel>
                                        <Input
                                            disabled
                                            className={classes.bottomLine}
                                            id="GST-return-document"
                                            value={formValues.gstReturnDoc}
                                            // onChange={handleChange('amount')}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className={classes.margin}>
                                        <InputLabel htmlFor="other-statements">Upload other statements</InputLabel>
                                        <Input
                                            disabled
                                            className={classes.bottomLine}
                                            id="other-statements"
                                            value={formValues.otherStatement}
                                            // onChange={handleChange('amount')}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div>
                        <div style={{ display: booksAcc }}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth className={classes.margin}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Which application do you use for maintaining the books of accounts ?
                                    </Typography>
                                </FormControl>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="tally"
                                        aria-label="business"
                                        name="customized-radios"
                                        onChange={handleRoleChange}
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="tally" control={<StyledRadio />} label="Tally" />
                                            </li>
                                            <li>
                                                <FormControlLabel value="zoho" control={<StyledRadio />} label="Zoho and QB" />
                                            </li>
                                            <li>
                                                <FormControlLabel value="others" control={<StyledRadio />} label="Others " />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                                <div style={{ display: tally }}>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">User ID</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.userID}
                                                    // onChange={handleChange('amount')}
                                                />
                                                <Typography variant="caption" gutterBottom>
                                                    Please provide the Login credentials if any
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Password</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.password}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <div>
                                                {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    className={clsx(classes.button, classes.mt15, classes.btnGrey)}
                                                >
                                                    Upload the Tally Data
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Do you have income from partnership firms ?
                                                </Typography>
                                            </FormControl>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    disabled
                                                    defaultValue="yes"
                                                    aria-label="yes-no"
                                                    name="customized-radios"
                                                    className="radio-option"
                                                >
                                                    <ul className={classes.inlineDisplay}>
                                                        <li>
                                                            <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                                        </li>
                                                        <li>
                                                            <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                                        </li>
                                                    </ul>
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Name of the firm</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.nameFirm}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Pan number of the firm</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.panNoFirm}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Remuneration received(in Rs)</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.remunRec}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Amount of interest(in Rs)</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.amtInt}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Share of profit(in %)</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.shareProfit}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Share of profit(in Rs)</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.shareProfitRs}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="book-application" className={classes.inLabel}>
                                                    Is the firm liable for audit?
                                                </InputLabel>
                                                <Select
                                                    // native
                                                    disable
                                                    value={state.tally}
                                                    onChange={handleChange}
                                                    inputProps={{
                                                        name: 'Is the firm liable for audit',
                                                        id: 'book-application',
                                                    }}
                                                    className={classes.bottomLine}
                                                >
                                                    <option aria-label="None" value="" />
                                                    <option value={10}>Tally</option>
                                                    <option value={20}>Zoho and QB</option>
                                                    <option value={30}>Others</option>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="book-application" className={classes.inLabel}>
                                                    Are transfer pricing provisions applicable to firm?
                                                </InputLabel>
                                                <Select
                                                    // native
                                                    disable
                                                    value={state.tally}
                                                    onChange={handleChange}
                                                    inputProps={{
                                                        name: 'Are transfer pricing provisions applicable to firm',
                                                        id: 'book-application',
                                                    }}
                                                    className={classes.bottomLine}
                                                >
                                                    <option aria-label="None" value="" />
                                                    <option value={10}>Tally</option>
                                                    <option value={20}>Zoho and QB</option>
                                                    <option value={30}>Others</option>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">
                                                    Balance of capital + current account in firm as on 31st March (in Rs.)
                                                </InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.shareProfitRs}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                            <div className="button-grid">
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    className={clsx(classes.button, classes.mt15, classes.btnGrey)}
                                                >
                                                    Add More
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div style={{ display: zoho }}>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">User ID</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.userID}
                                                    // onChange={handleChange('amount')}
                                                />
                                                <Typography variant="caption" gutterBottom>
                                                    Please provide the Login credentials if any
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className={classes.margin}>
                                                <InputLabel htmlFor="standard-adornment-amount">Password</InputLabel>
                                                <Input
                                                    disabled
                                                    className={classes.bottomLine}
                                                    id="standard-adornment-amount"
                                                    value={formValues.password}
                                                    // onChange={handleChange('amount')}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div style={{ display: others }}>
                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth className={classes.margin}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Account details
                                            </Typography>
                                        </FormControl>
                                        <FormControl fullWidth className={classes.margin}>
                                            <InputLabel htmlFor="standard-adornment-amount">Enter details of accounts</InputLabel>
                                            <Input
                                                disabled
                                                className={classes.bottomLine}
                                                id="standard-adornment-amount"
                                                value={formValues.accDetails}
                                                // onChange={handleChange('amount')}
                                            />
                                        </FormControl>
                                    </Grid>
                                </div>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Have you sold any assets this year?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Choose the nature of assets, which are sold during the year?
                            </Typography>
                            {/* <div>
                                <FormControl fullWidth className={classes.margin}>
                                    <InputLabel htmlFor="enter-the-nature">Enter the nature</InputLabel>
                                    <Input
                                        disabled
                                        className={classes.bottomLine}
                                        id="enter-the-nature"
                                        value={formValues.natureAssets}
                                        // onChange={handleChange('amount')}
                                    />
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <div>
                                                <Button variant="outlined" color="primary" className={classes.button}>
                                                    Add More
                                                </Button>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <Button variant="outlined" color="primary" className={classes.button}>
                                                    Add Attachment if any
                                                </Button>
                                            </div>
                                        </li>
                                    </ul>
                                </FormControl>
                            </div> */}

                            <div>
                                <Grid item xs={12} sm={12} style={{ display: 'flex', paddingLeft: '0' }}>
                                    <Grid item xs={8} sm={4} style={{ paddingLeft: '0' }}>
                                        <FormControl fullWidth className={classes.margin}>
                                            <div className="mt15">
                                                <FormControl fullWidth className={classes.margin}>
                                                    <InputLabel htmlFor="enter-the-nature" className={classes.inLabel} shrink>
                                                        Select the nature
                                                    </InputLabel>
                                                    {/* <Field name={`capitalgain[${gainindex}].natureAssets`}>
                                                    {(fieldProps) => {
                                                        //console.log(
                                                        //     fieldProps,
                                                        //     'Field Props of Capital Gain'
                                                        // );
                                                        const { field, meta } = fieldProps;
                                                        return (
                                                            <> */}
                                                    {/* <Select
                                                        native
                                                        placeholder="Select Nature"
                                                        className={classes.selectView}
                                                        disabled
                                                    >
                                                        <MenuItem value="Select Nature">
                                                            Select Nature
                                                        </MenuItem>
                                                    </Select> */}
                                                    <Select
                                                        disabled
                                                        native
                                                        // value={state.year}
                                                        onChange={handleChange}
                                                        inputProps={{
                                                            name: 'Select Nature',
                                                            id: 'year',
                                                        }}
                                                        className={classes.bottomLine}
                                                    >
                                                        <option aria-label="None" value="Select Nature" />
                                                    </Select>
                                                    {/* </>
                                                        );
                                                    }}
                                                </Field> */}
                                                </FormControl>
                                            </div>
                                        </FormControl>
                                    </Grid>
                                    {/* <Grid item xs={12} sm={6} style={{ paddingLeft: '0' }}>
                                        <div style={{ top: '30px', right: '0px', marginTop: '46px', marginLeft: '14px' }}>
                                            <Button variant="outlined" color="primary" className={classes.uploadBtn}>
                                                Upload
                                            </Button>
                                            
                                        </div>
                                    </Grid> */}
                                </Grid>

                                <ul className={classes.inlineDisplay}>
                                    <li>
                                        <div>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                className={clsx(classes.button, classes.mt15, classes.btnGrey)}
                                            >
                                                Add More
                                            </Button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </FormControl>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={4} className="divident-income">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you have any incomes which are not explicitly covered earlier?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Dividend Income
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="divPayer">Name of the Payer</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="divPayer"
                                value={formValues.divPayer}
                                // onChange={handleChange('amount')}
                            />
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Add More
                                        </Button>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Add Attachment if any
                                        </Button>
                                    </div>
                                </li>
                            </ul>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="divAmount">Amount(in Rs)</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="divAmount"
                                value={formValues.divAmount}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom className="mt15">
                                FD interest
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="fdPayer">Name of the Payer</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="fdPayer"
                                value={formValues.fdPayer}
                                // onChange={handleChange('amount')}
                            />
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Add More
                                        </Button>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Add Attachment if any
                                        </Button>
                                    </div>
                                </li>
                            </ul>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="fdAmount">Amount(in Rs)</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="fdAmount"
                                value={formValues.fdAmount}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom className="mt15">
                                Other Incomes
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="otherPayer">Name of the Payer</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="otherPayer"
                                value={formValues.otherPayer}
                                // onChange={handleChange('amount')}
                            />
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Add More
                                        </Button>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                        <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                            Add Attachment if any
                                        </Button>
                                    </div>
                                </li>
                            </ul>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="otherAmount">Amount(in Rs)</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="otherAmount"
                                value={formValues.otherAmount}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={5}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you have any agricultural income?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Nature of Agricultural Income
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="agriculture-name">Name </InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="agriculture-name"
                                value={formValues.agricultureName}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="agriAmount">Amount(in Rs)</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="agriAmount"
                                value={formValues.agriAmount}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="agriculture-receipt">Receipt </InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="agriculture-receipt"
                                value={formValues.agriReceipt}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="agriExpenses">Expenses</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="agriExpenses"
                                value={formValues.agriExpenses}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <ul className={classes.inlineDisplay} style={{ paddingLeft: '12px' }}>
                        <li>
                            <div>
                                <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                                    Add More
                                </Button>
                            </div>
                        </li>
                    </ul>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={6}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Details of investments/savings like LIC premium, Mediclaim, PPF, NSC, Children school fees etc..
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="investments">Particulars</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="investments"
                                value={formValues.investment}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="amount-investment">Amount</InputLabel>
                            <Input disabled className={classes.bottomLine} id="amount-investment" value={formValues.investmentAmt} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Donation details
                            </Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="donation-details">Particulars</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="donation-details"
                                value={formValues.donationDetails}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="donation-amount">Amount</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="donation-amount"
                                value={formValues.donationAmt}

                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </TabPanel>
        </div>
    );
}
